<template>
  <a
    class="cta-button"
    :class="{ disabled: this.isDisabled }"
    :style="{
      'background-color': this.bgColor,
      color: this.textColor,
      'border-color': this.hasBorder ? '#1d2124' : 'transparent',
    }"
    :href="url"
    :target="urlTarget"
    @click="onClick"
  >
    <slot />
  </a>
</template>

<script>
export default {
  name: "CallToActionButton",
  props: {
    bgColor: {
      type: String,
      required: false,
    },
    textColor: {
      type: String,
      required: false,
    },
    hasBorder: {
      type: Boolean,
      required: false,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    url: {
      type: String,
      required: false,
    },
  },
  computed: {
    urlTarget() {
      return !this.url || this.url.indexOf("xing.com") !== -1
        ? "_self"
        : "_blank";
    },
  },
  methods: {
    onClick() {
      if (!this.isDisabled) {
        this.$emit("clicked");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cta-button {
  @apply cursor-pointer text-center;
  padding: 10px 21px;
  border: 2px solid;
  box-sizing: border-box;
  border-radius: 21px;
  font-weight: bold;
  font-size: 18px;
  line-height: 18px;
  color: #1d2124;

  &:hover {
    background: #ececec !important;
    color: #1d2124 !important;
  }
}

.disabled {
  background: #696f79 !important;
  color: #ffffff !important;
  cursor: not-allowed;

  &:hover {
    background: #696f79 !important;
    color: #ffffff !important;
  }
}
</style>
